define("shared/components/shared/wizards/carousel/step-three", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="tOB--wizard">
    {{! Image }}
    <div class="tOB--wizard__left">
      <img class="o--media" src="/assets/images/img--multiPost--slide4.gif" />
    </div>
    {{! Description }}
    <div class="tOB--wizard__right">
      <h3 class="tOB--wizard__title">
        {{t "tutorials.multi_image.slide_3.title"}}
      </h3>
      <ul class="tOB--wizard__ul">
        <li class="tOB--wizard__li">
          {{this.autoPublishText}}
        </li>
        <li class="tOB--wizard__li">
          <span class="tOB--wizard__step">
            {{t "wizards.shared.step_1"}}
          </span>
          <p>
            {{t "tutorials.multi_image.slide_3.point_1"}}
          </p>
        </li>
        <li class="tOB--wizard__li">
          <span class="tOB--wizard__step">
            {{t "wizards.shared.step_2"}}
          </span>
          <p>
            {{t "tutorials.multi_image.slide_3.point_2"}}
          </p>
        </li>
        <li class="tOB--wizard__li">
          <span class="tOB--wizard__step">
            {{t "wizards.shared.step_3"}}
          </span>
          <p>
            {{t "tutorials.multi_image.slide_3.point_3"}}
          </p>
        </li>
      </ul>
      <hr />
      <form class="o--formWrapper u--m__b__0 u--m__t__lg">
        <div class="o--form__checkbox at--multiImageTutorial__checkbox">
          <label class="u--text--bold u--m__l__xs">
            <Input @checked={{@educationBoxChecked}} @type="checkbox" />
            {{t "tutorials.multi_image.slide_3.understand"}}
          </label>
        </div>
      </form>
    </div>
  </section>
  */
  {
    "id": "caE8ne9j",
    "block": "[[[10,\"section\"],[14,0,\"tOB--wizard\"],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tOB--wizard__left\"],[12],[1,\"\\n    \"],[10,\"img\"],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--multiPost--slide4.gif\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tOB--wizard__right\"],[12],[1,\"\\n    \"],[10,\"h3\"],[14,0,\"tOB--wizard__title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_3.title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"ul\"],[14,0,\"tOB--wizard__ul\"],[12],[1,\"\\n      \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n        \"],[1,[30,0,[\"autoPublishText\"]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"tOB--wizard__step\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"wizards.shared.step_1\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_3.point_1\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"tOB--wizard__step\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"wizards.shared.step_2\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_3.point_2\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"tOB--wizard__step\"],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"wizards.shared.step_3\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[12],[1,\"\\n          \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_3.point_3\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"hr\"],[12],[13],[1,\"\\n    \"],[10,\"form\"],[14,0,\"o--formWrapper u--m__b__0 u--m__t__lg\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--form__checkbox at--multiImageTutorial__checkbox\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"u--text--bold u--m__l__xs\"],[12],[1,\"\\n          \"],[8,[39,1],null,[[\"@checked\",\"@type\"],[[30,1],\"checkbox\"]],null],[1,\"\\n          \"],[1,[28,[35,0],[\"tutorials.multi_image.slide_3.understand\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@educationBoxChecked\"],false,[\"t\",\"input\"]]",
    "moduleName": "shared/components/shared/wizards/carousel/step-three.hbs",
    "isStrictMode": false
  });
  let StepThreeComponent = _exports.default = (_class = class StepThreeComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
    }
    get autoPublishText() {
      if (this.args.canAutoPublish) {
        return this.intl.t('tutorials.multi_image.slide_3.info_auto');
      }
      return this.intl.t('tutorials.multi_image.slide_3.info');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, StepThreeComponent);
});